import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import store from 'store'
import {addItemToBox, closeBox, getBoxDetail, getListBoxItems} from "../../../services/api/apiNextBox"
import {pushNewItemHistory} from "../../../services/api/apiItemHistory"
import NextBoxDetail from "./NextBoxDetail"
import { getRoles } from '../../../services/AuthServices'


class NextBoxPage extends Component {
    state = {
        box: null,
        barcodeError: store.get('barcodeError') || [],
        loading: false,
        error: '',
        items: [],
    }

    componentDidMount() {
        this._fetchBoxDetail()
        this._fetchListBoxItems()
    }

    _fetchListBoxItems = async () => {
        try {
            const {success, data, message} = await getListBoxItems(this.props.boxId)

            if (!success) {
                throw new Error(message)
            }

            const {items} = Object.assign({}, data)

            return this.setState({
                items: Array.isArray(items) ? items : []
            })
        } catch (e) {
            this.setState({
                error: e.message || e,
            })
        }
    }

    _fetchBoxDetail = async () => {
        if (this.state.loading) return true

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {success, data, message} = await getBoxDetail(this.props.boxId)

            if (!success) {
                throw new Error(message)
            }

            return this.setState({
                box: data,
                loading: false,
                error: ''
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message || e,
                box: null,
            })
        }
    }

    _handleSubmit = async (barcode) => {
        const vBarcode = (barcode ? barcode.trim() : '').replace(/#/gi, '')

        if (!vBarcode) {
            throw new Error('Barcode is invalid.')
        }

        console.log('Add barcode:', vBarcode)

        const {success, data, message} = await addItemToBox(this.props.boxId, vBarcode)

        if (!success) {
            throw new Error(message)
        }

        await this._fetchBoxDetail()

        return this._pushNewItem(data)
    }

    _handleOnClose = async (payload) => {
        try {
            const {success, message} = await closeBox(this.props.boxId, payload)

            if (!success) {
                throw new Error(message)
            }

            await Promise.all([
                this._fetchBoxDetail(),
                this._fetchListBoxItems()
            ])

            this.setState({
                barcodeError: []
            }, store.remove('barcodeError'))

            return this.props.reloadClosedBox(this.state.box.closed_at)
        } catch (e) {
            window.alert('Lỗi: ' + e.message)
        }
    }

    _pushNewItem = (newItems) => {
        if (!newItems || !newItems.length) return false

        const {items} = this.state
        const vItems = newItems.filter(newItem => {
            const {item_number, item_index} = newItem
            const existing = items.find(item => {
                return item && item.item_number === item_number && item.item_index === item_index
            })

            return !existing
        })

        if (!vItems.length) return true

        this.setState({
            items: [].concat(vItems, items)
        }, () => {
            const {id} = Object.assign({}, this.state.box)

            return Promise.all(vItems.map(newItem => {
                const {item_number} = newItem

                return pushNewItemHistory(`${item_number}_1`, {
                    event_key: 'scan_to_package',
                    event_description: 'Scan QR to package.',
                    event_meta: {
                        box_number: id,
                    }
                })
            }))
        })

        return true
    }


    _handleOnRefresh = async () => {
        await Promise.all([
            this._fetchBoxDetail(),
            this._fetchListBoxItems(),
        ])
    }

    _handleUpdateLocalStore = (box_id, error) => {
        const barcodeError = store.get('barcodeError') || []
        const boxExits = barcodeError.find(item => item.boxID === box_id)
        let newBarcodes = []

        if (boxExits !== undefined) {
            newBarcodes = barcodeError.map(item => {
                if (item.boxID === box_id) {
                    return {
                        boxID: box_id,
                        barcodes: item.barcodes.concat(error)
                    }
                } else {
                    return item
                }
            })
        } else {
            newBarcodes = barcodeError.map(item => item)
            newBarcodes.push({
                boxID: box_id,
                barcodes: error
            })
        }

        this.setState({
            barcodeError: newBarcodes
        }, () => {
            store.set('barcodeError', newBarcodes)
        })
    }

    render() {
        const {loading, box, items, barcodeError} = this.state
        const {isPrivate} = this.props
        const {indexBoxClosed} = this.props
        const Roles = getRoles()
        const listRole = Roles && Roles.length > 0 ? Roles.map(i=>i.name) : []
        const isAdmin = listRole.includes('fac_admin')

        return (
            <div className={classNames("NextBoxPage", {loading})}>
                {
                    !!box && <NextBoxDetail
                        barcodeError={barcodeError}
                        isPrivate={isPrivate}
                        isAdmin={isAdmin}
                        box={box}
                        items={items}
                        indexBoxClosed={indexBoxClosed}
                        onClose={this._handleOnClose}
                        onUpdateLocalStore={this._handleUpdateLocalStore}
                        onRefresh={this._handleOnRefresh}
                        loading={loading}
                    />
                }
            </div>
        )
    }
}

NextBoxPage.propTypes = {
    boxId: PropTypes.string.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    indexBoxClosed: PropTypes.number
}

export default NextBoxPage
